import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "./services/auth/auth.service";
import { SocketService } from "./services/socket.service";
import { Router } from "@angular/router";
import { Keepalive } from "@ng-idle/keepalive";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { UtilityService } from "./services/utility.service";
import { LogoutService } from "./services/logout.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  isCustomLayout = false;
  show: boolean = false;
  public static showLoader = true;

  timedOut = false;
  lastPing?: Date | null = null;
  IDLE_TIMEOUT = 5 * 60; // sets an idle timeout of 5 mins.
  INACTIVITY_TIMEOUT = 10; // sets a timeout period of 10 seconds. after 10 seconds of inactivity, the user will be considered timed out.
  PING_INTERVAL = 20; // sets the ping interval to 20 seconds

  constructor(
    public translate: TranslateService,
    public authService: AuthService,
    private socket: SocketService,
    public helper: UtilityService,
    private idle: Idle,
    keepalive: Keepalive,
    private router: Router,
    private translateService: TranslateService,
    private logoutService: LogoutService,
  ) {
    this.authService.currentUserValue.subscribe((x) => (this.show = x));
    translate.setDefaultLang("en");
    idle.setIdle(this.IDLE_TIMEOUT);
    idle.setTimeout(this.INACTIVITY_TIMEOUT);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.timedOut = true;
      console.log("out");
      localStorage.removeItem("token");
      this.logoutService.logoutUser("idleLogout");
      this.helper.showSuccessToast(this.translateService.instant("idleLogout"));
    });

    idle.onIdleStart.subscribe(() => {});

    idle.onTimeoutWarning.subscribe((countdown) => {});

    keepalive.interval(this.PING_INTERVAL);
    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));
    this.reset();
  }

  reset() {
    this.idle.watch();
    this.timedOut = false;
  }
}
